import React from 'react'

const ChapterIcon = ({ name }) => {
  if (!name) return <span className="hc-sidebar__chapter-icon" aria-hidden="true">📘</span>
  return (
    <span className="hc-sidebar__chapter-icon" aria-hidden="true">
      <i className={`fa fa-${name}`} />
    </span>
  )
}

const Sidebar = ({ tree, currentSlug, expanded, onToggleChapter, onSelect, onSelectChapter }) => (
  <nav className="hc-sidebar" aria-label={I18n.t('help_center_modal.sidebar_label')}>
    <ul className="hc-sidebar__list">
      {tree.map(chapter => {
        const isExpanded = expanded[chapter.key] !== false
        const isCurrentChapter = currentSlug === chapter.key
        return (
          <li key={chapter.key} className="hc-sidebar__chapter">
            <button
              type="button"
              className={`hc-sidebar__chapter-toggle${isCurrentChapter ? ' is-active' : ''}`}
              aria-expanded={isExpanded}
              onClick={() => onToggleChapter(chapter.key)}
            >
              <span className={`hc-sidebar__caret${isExpanded ? ' is-open' : ''}`} aria-hidden="true">▸</span>
              <ChapterIcon name={chapter.icon} />
              <span
                className="hc-sidebar__chapter-title"
                onClick={e => {
                  if (chapter.intro) {
                    e.stopPropagation()
                    onSelectChapter(chapter.key)
                  }
                }}
              >
                {chapter.title}
              </span>
            </button>
            {isExpanded && (
              <ul className="hc-sidebar__articles">
                {chapter.articles.map(article => (
                  <li key={article.slug}>
                    <button
                      type="button"
                      className={`hc-sidebar__article${article.slug === currentSlug ? ' is-active' : ''}`}
                      onClick={() => onSelect(article.slug)}
                    >
                      {article.title}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </li>
        )
      })}
    </ul>
  </nav>
)

export default Sidebar
